import React, { forwardRef, LiHTMLAttributes, useId } from 'react';
import { css } from '@emotion/react';
import {
  dropdown_item_base_css,
  dropdown_item_disabled_style,
  dropdown_item_selected_style,
  dropdown_item_focused_style,
  getDropdownItemFontStyle,
  getDropdownItemSizeStyle,
} from './styles';
import { InputSize } from '../input/types';
import { buildCSSWithLength } from '../../styles';

export interface DropdownItemProps extends LiHTMLAttributes<HTMLLIElement> {
  disabled?: boolean;
  /**
   *  @default false
   *  Option 선택 여부
   */
  selected?: boolean;
  /**
   *  @default false
   *  Option focus 여부
   */
  focused?: boolean;
  size?: InputSize;
  optionItemHeight?: number;
}

export const DropdownItem = forwardRef<HTMLLIElement, DropdownItemProps>(
  ({ children, disabled, selected = false, focused = false, size = 'medium', optionItemHeight, ...props }, ref) => {
    const id = useId();
    const props_style = {
      ...(selected && dropdown_item_selected_style),
      ...(focused && dropdown_item_focused_style),
      ...(disabled && dropdown_item_disabled_style),
    };

    return (
      <li
        role='option'
        id={`pds-dropdown-option-${id}`}
        css={[
          dropdown_item_base_css,
          getDropdownItemSizeStyle(size),
          getDropdownItemFontStyle(size),
          props_style,
          css`
            ${selected && `font-weight: 600;`}
            ${optionItemHeight && buildCSSWithLength('height', optionItemHeight)}
          `,
        ]}
        {...props}
        ref={ref}
      >
        {children}
      </li>
    );
  },
);
